/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React, { useContext } from 'react';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import { Link as ScrollLink } from 'react-scroll';
import { useTranslation } from 'react-i18next';
import { scrollerSettings } from '../../../../settings';
import { CardContext } from '../CardContext';

export default function CardLinkAction() {
  const { sectionName } = useContext(CardContext);
  const { t } = useTranslation();

  return (
    <ScrollLink
      activeClass="active"
      to={sectionName}
      spy={true}
      smooth={scrollerSettings.smooth}
      offset={scrollerSettings.offset}
      delay={scrollerSettings.delay}
      duration={scrollerSettings.duration}
    >
      <IconButton aria-label={t('actions.view')}>
        <EditIcon />
      </IconButton>
    </ScrollLink>
  );
}
